import { Component, forwardRef, Input, OnInit } from "@angular/core";
import {
    AbstractControl,
    ControlValueAccessor,
    UntypedFormBuilder,
    UntypedFormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors,
    Validator
} from "@angular/forms";
import { NameId } from "app/shared/types";

const KEY_ENTER = "Enter";
const KEY_COMMA = ",";
const KEY_BACKSPACE = "Backspace";

@Component({
    selector: "app-tag-input",
    templateUrl: "./tag-input.component.html",
    styleUrls: ["./tag-input.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TagInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: TagInputComponent
        }
    ]
})
export class TagInputComponent implements ControlValueAccessor, Validator, OnInit {
    @Input() unique = true;

    valid = true;
    disabled = false;
    tags = [];
    onChange: any = () => {};
    onTouched: any = () => {};

    form: UntypedFormGroup;

    constructor(private _fb: UntypedFormBuilder) {}

    ngOnInit(): void {
        this.form = this._fb.group({
            tagInput: [""]
        });
    }

    onBlur(event: Event): void {
        const tag = this.form.get("tagInput").value || "";
        this.addTag(tag.trim());
        this.form.get("tagInput").reset();
    }

    onKeyUp(event: KeyboardEvent): void {
        let tag = this.form.get("tagInput").value;
        if (event.key === KEY_ENTER || event.key === KEY_COMMA) {
            if (event.key === KEY_COMMA) {
                tag = tag.slice(0, -1);
            }
            this.addTag(tag.trim());
            this.form.get("tagInput").reset();
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        const tag = this.form.get("tagInput").value;

        if (event.key === KEY_BACKSPACE && !tag && this.tags.length) {
            this.removeTag(this.tags.length - 1);
        }
    }

    addTag(text: string): void {
        if (this.disabled) return;

        if (text) {
            this.tags = [...this.tags, { id: null, name: text }];
            this.onChange(this.tags);
        }
    }

    removeTag(index: number): void {
        if (this.disabled) return;

        this.tags.splice(index, 1);
        this.tags = [...this.tags];
        this.onChange(this.tags);
    }

    writeValue(value: NameId[]): void {
        this.tags = value || [];
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
        if (isDisabled) {
            this.form.get("tagInput").disable();
        } else {
            this.form.get("tagInput").enable();
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (this.unique) {
            const tagNames = this.tags.map(x => x.name.toLowerCase());
            const uniqueNames = [...new Set(tagNames)];

            if (tagNames.length !== uniqueNames.length) {
                this.valid = false;
                return {
                    tagsMustBeUnique: true
                };
            }
        }
        this.valid = true;
        return null;
    }
}
